import React, { useState, useContext } from "react"
import { Button, Container, Divider, Grid, useMediaQuery} from "@material-ui/core"
import { BrowserView, MobileView } from "react-device-detect"
import FlexView from "react-flexview/lib"
import { SessionContextStore, SESSION_ACTIONS } from "../../context/SessionContext"
import { UserApi } from "../../api/user.api"
import { EventEmitterService, EventKey } from "../../services/EventEmitterService"
import './UserProfile.scss'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AddressSection } from "./ProfileSections/AddressSection"
import { UserSection } from "./ProfileSections/UserSection"
import { UserProfileContextStore } from "../../context/UserProfileContext"
import DoneIcon from '@material-ui/icons/Done';
import { awaitWithLoading, isInFlow, showError, isInClaimsFlow, isInPurchaseFlow, isOver18 } from "../../services/utils"
import { useLocation, useHistory } from "react-router-dom"
import { BackButton } from "../Core/Buttons/BackButton"
import { ContinueButton } from "../Core/Buttons/ContinueButton"
import { BottomSheetPolicySummary } from "../Insurance/BottomSheetPolicySummary"
import NewFillButton from "../Core/NewFillButton"
import { TextDivider } from "../Core/TextDivier"
import { FirebaseService, FirebaseConfigKey } from "../../services/FirebaseService"
import { SessionService } from "../../services/SessionService"
import DataLayerService from "../../services/DataLayerService"
import { GetAQuotePopup } from "../Quote/GetAQuotePopup";
import { Experiment, Variant } from "react-optimize";
import { CompanySection } from './ProfileSections/CompanySection';
import { OptionalTag } from "../Core/OptionalTag"
import BrokerConfigService from "../../services/BrokerConfigService"
import { AgentSection } from "./ProfileSections/AgentSection"
import { SkywatchDialog } from "../PopUps/SkywatchDialog"
import {BuyingInsuranceContextStore, FLOW_TYPES} from "../../context/BuyingInsuranceContext"
import { InsurancePurchaseContextStore } from "../../context/InsuracePurchaseContext";
import { ReferralQuestionsSection } from "./ProfileSections/ReferralQuestionsSection"
import { InsuranceHistorySection } from "./ProfileSections/RefferalQuestions/InsuranceHistorySection"
import UploadFleetDocumentSection from "./ProfileSections/UploadFleetDocumentSection"


var dayjs = require('dayjs')

export const UserProfile = (props) => {
    const location = useLocation()
    const history = useHistory()
    const context = useContext(SessionContextStore)
    const profileContext = useContext(UserProfileContextStore)
    const insuranceContext = useContext(InsurancePurchaseContextStore)
    const offerContext = useContext(BuyingInsuranceContextStore)
    const [registerMode, setRegisterMode] = useState((location.pathname.endsWith('register') || isInFlow(location.pathname) && !location.pathname.startsWith('/claim')))
    const [isNetworkBroker, setIsNetworkBroker] = useState(false)
    const [showExistingUserPopup, setShowExistingUserPopup] = useState(false)
    const [shouldDisableResend, setShouldDisableResend] = useState(false)
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));

    const isAddressValid = () => {
        return profileContext.address.address_line_1 && profileContext.address.city
            && profileContext.address.state != 'statedefault' && profileContext.address.zipcode
    }

    const isUserInfoValid = () => {
        return profileContext.user_info.fname && profileContext.user_info.lname
            // && isOver18(dayjs(profileContext.user_info.dob, FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT))) && profileContext.user_info.flight_purpose != 'default'
    }
    
    const isHistoryValid = () => {
        return profileContext.insurance_history.had_incidents_or_losses && profileContext.insurance_history.had_felony
    }

    const isAgentInfoValid = () => {
        return profileContext.agent_info.agent_name && profileContext.agent_info.agent_email
    }

    const [insuranceHistoryValid, setInsuranceHistoryValid] = useState(isAddressValid())

    const save = async () => {
        EventEmitterService.dispatch(EventKey.USER_PROFILE_SAVE)
        DataLayerService.pushToDataLayer({'event': 'continue-at-profile'})
        setInsuranceHistoryValid(true)
    }

    const isInProfile = location.pathname == '/account/profile'
    const isInProposal = location.pathname == '/proposal/profile'

    React.useEffect(() => {
        DataLayerService.pushToDataLayer({'event': 'profile-page-loaded'})
        BrokerConfigService.isNetworkBroker().then(result => setIsNetworkBroker(result))
    },[])

    React.useEffect(() => {
        async function uploadProfileData() {
            let res = {}
            if (!SessionService.isLoggedIn() && isInPurchaseFlow(location.pathname)){
                
                const selections = {
                    main: insuranceContext.selectedOption,
                    additional: {
                        personalInjuryCoverage: offerContext.personalInjuryCoverage,
                        medicalExpense: offerContext.medicalExpense,
                        numberOfDronesOperate: offerContext.numberOfDronesOperate,
                        numberOfDronesText: offerContext.numberOfDronesText
                    },
                }
                res = await awaitWithLoading(context.registerPasswordless(profileContext.user_info.email, JSON.stringify(selections)))
            }
            if (res.ok || SessionService.isLoggedIn()) {
                const hasHull= insuranceContext.drones.length != 0 || insuranceContext.equipment.length != 0
                let resProfile = await awaitWithLoading(UserApi.saveProfile({...profileContext, ...offerContext.fleetInformation, flowType: offerContext.flowType, selectedLiability: insuranceContext.selectedOption.liabilityLimit, planDuration:insuranceContext.selectedOption.billingPeriod, hasHull: hasHull, finalPrice: insuranceContext.selectedOption.finalPrice},insuranceContext.selectedOption.offerId, context.companyPictureFile));
                profileContext.dispatch({ type: 'RESET' })
                if (resProfile.ok) {
                    if(context.companyPictureFile) {
                        EventEmitterService.dispatch(EventKey.USER_PROFILE_IMAGE_UPDATED, { url: resProfile.data.image_url })
                    }
                    DataLayerService.pushToDataLayer({ event: 'successful-profile-saved' })
                    context.dispatch({ type: SESSION_ACTIONS.UPDATE_USER_PROFILE, data: { ...resProfile.parsedData} })
                    if (location.pathname == '/insurance/profile')
                    EventEmitterService.dispatch(EventKey.FLOW_PROFILE_FINISH, resProfile.parsedData)
                    else if (location.pathname == '/account/profile') {
                        EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Profile saved successfully' })
                    }
                    else
                    EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Success!', body: 'Your details were sent to your broker' })
                    window.clarityUpdateUserId(resProfile.data.email)
                }
                else {
                    if(resProfile.data.messages.type.includes("declination")){
                        await context.getUser()
                        const property_name= resProfile.data.messages.PropertyName[0]
                        const maximum_allowed_limit= resProfile.data.messages.liabilityLimitAllow[0]
                        history.push('/declination', { property_name: property_name, maximum_allowed_limit: maximum_allowed_limit})
                    }
                    else if(resProfile.data.messages.type.includes("UUD")){
                        await context.getUser()
                        history.push('/uud')
                    }
                    else{
                        EventEmitterService.dispatch(EventKey.ShowError, resProfile)
                    }
                }
            } else {
                if(res.data?.code === 102){
                    setShowExistingUserPopup(true)
                    window.clarityUpdateUserId(profileContext.user_info.email)
                }else{
                    EventEmitterService.dispatch(EventKey.ShowError, res)
                }
                
            }
        }

        const agentValidation = !isNetworkBroker ? true : profileContext.agent_info_saved && isAgentInfoValid()
        const fieldValidation = isUserInfoValid() && isAddressValid() && isHistoryValid();
        if (profileContext.user_info_saved && profileContext.insurance_history_saved && profileContext.address_saved && 
            (profileContext.fleet_saved || offerContext.flowType === FLOW_TYPES.REGULAR || SessionService.isAdmin()) 
            && fieldValidation && agentValidation) {
            
            uploadProfileData()
            profileContext.setError(null);
        }
        
    }, [profileContext.user_info_saved, profileContext.insurance_history_saved, profileContext.address_saved, profileContext.agent_info_saved,profileContext.fleet_saved])
    
    return (
        <React.Fragment>
            {!isMobile ?
                <Container maxWidth="md" className="margin-top-medium">
                    {!BrokerConfigService.isSkywatchBroker() && isNetworkBroker && 
                        <>
                            <AgentSection/>
                            <div className="margin-top-17"></div>
                        </>
                    }
                    <UserSection />
                    <Divider />
                    <div className="text-small-title black bold">Address</div>
                    <AddressSection />
                    <Divider />
                    <Grid container >
                        <span className="text-small-title black bold margin-right-6">Company Info</span><OptionalTag />
                    </Grid>
                    <CompanySection />
                    { offerContext.flowType === FLOW_TYPES.FLEET && <UploadFleetDocumentSection/>}
                    <Divider />
                    <div className="text-small-title black bold">Insurance History</div>
                    <InsuranceHistorySection />
                    {location.pathname == '/insurance/profile' && <div className="margin-top-basic">
                    {profileContext.hasError && <div className="red">{profileContext.hasError}</div>}
                    <FlexView className="margin-top-small margin-bottom-basic">
                        <BackButton />
                        <ContinueButton onClick={save} />
                        <div className="margin-left-12">
                            {!location.pathname.startsWith('/proposal') && SessionService.isBroker() && <GetAQuotePopup />}
                        </div>
                    </FlexView>
                    </div>
                    }
                    {isInProfile && <FlexView className="margin-top-small margin-bottom-basic">
                        <NewFillButton onClick={save}>Save Changes</NewFillButton>
                    </FlexView>}
                    {isInProposal && <FlexView vAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                        <BackButton />
                        <div className="margin-left-12">
                            <NewFillButton onClick={save}>Send to broker</NewFillButton>
                        </div>
                    </FlexView>}
                </Container>
            :
                <Container maxWidth="lg" className="margin-top-medium">
                {!BrokerConfigService.isSkywatchBroker() && isNetworkBroker && 
                    <>
                    <div className="margin-top-medium margin-bottom-medium">
                        <TextDivider><div className="text-title bold blue">Agency Details</div></TextDivider>
                    </div>

                        <div className="text-title black">Agency Info</div>
                            {isAgentInfoValid() && <DoneIcon className="green margin-left-6" />}
                            <AgentSection/>
                    </>}
                    <div className="margin-top-medium margin-bottom-medium">
                        <TextDivider><div className="text-title bold blue">{SessionService.isBroker() ? "Insured's" : "Profile"} Details</div></TextDivider>
                    </div>
                            <div className="text-title black">Personal Info</div>
                            <UserSection />
                            <Divider/>
                            <div className="text-title black">Address</div>
                            <AddressSection />
                            <Divider/>
                            <Grid container >
                                <span className="text-title black margin-right-6">Company Info</span><OptionalTag />
                            </Grid>
                            <CompanySection />
                            { offerContext.flowType === FLOW_TYPES.FLEET && <UploadFleetDocumentSection/>}
                            <Divider/>
                            <div className="text-title black">Insurance History</div>
                            <div>
                                <InsuranceHistorySection />
                            </div>
                {location.pathname === '/insurance/profile' && <>
                    {isMobile ? <BottomSheetPolicySummary title={'Continue'} onClick={save} /> : <FlexView className="margin-top-small margin-bottom-basic">
                        <BackButton />
                        <ContinueButton onClick={save} />
                        <div className="margin-left-12">
                            {!location.pathname.startsWith('/proposal') && SessionService.isBroker() && <GetAQuotePopup />}
                        </div>
                    </FlexView>}
                </>
                }
                {isInProfile && <FlexView hAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                    <NewFillButton onClick={save}>Save Changes</NewFillButton>
                </FlexView>}
                {isInProposal && <FlexView hAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                    <NewFillButton onClick={save}>Send to broker</NewFillButton>
                </FlexView>}
                </Container>}


        <SkywatchDialog 
            // open={showExistingUserPopup} 
            open={showExistingUserPopup} 
            maxWidth={'sm'}
            includeCancelButton={true}
            closeDialog={() => setShowExistingUserPopup(false)}
        >
                <div className="blue bold text-title textcenter margin-bottom-basic">Check your inbox</div>
                <div className="textcenter"><b>Welcome back!</b> It looks like you've registered with us before.</div>
                <div className="textcenter">To make logging in even easier, we've sent a magic link to your email <span className="blue bold">{profileContext.user_info.email}.</span></div>
                <div className="textcenter margin-bottom-basic">Simply click on the link, and you'll be instantly logged into your account.</div>
                <div className="textcenter margin-bottom-basic">Can't find the email? Check your spam folder or click on the resend button below.</div>

                <Grid container justifyContent="center">
                    <NewFillButton disabled={shouldDisableResend} onClick={() => {
                        setShouldDisableResend(true);
                        awaitWithLoading(context.registerPasswordless(profileContext.user_info.email, JSON.stringify(insuranceContext.selectedOption)))
                        setTimeout(() => setShouldDisableResend(false), 2000);
                    }}>Resend email</NewFillButton>
                </Grid>
        </SkywatchDialog>
       </React.Fragment>
    )
}